import React from 'react';
import styled from 'styled-components';

const StyledPageTitle = styled.h2`
    color: #111111;
    font-size: 2.125rem;
    font-weight: bold;
    margin-top: 3rem;
    margin-bottom: 1.5rem;
`;

interface PageTitleProps {
    className?: string;
    id?: string;
    children?: React.ReactNode;
    'aria-label'?: string;
}
const PageTitle: React.FunctionComponent<PageTitleProps> = ({ children, ...props }) => {
    return <StyledPageTitle {...props}>{children}</StyledPageTitle>;
};

export default PageTitle;
